import React from 'react';

const RegAvatarSVG = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 27 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0141 24.0524H16.3875V22.5769C20.3816 21.7439 23.2841 18.8586 23.2841 11.9037C23.2841 4.16077 18.9032 0.956543 13.4995 0.956543C8.09585 0.956543 3.71496 4.22745 3.71496 11.9037C3.71496 18.7905 6.56145 21.686 10.4953 22.5508V24.0524H7.98543C3.5756 24.0524 0 27.6345 0 32.0538V35H27V32.0538C27 27.6345 23.4244 24.0524 19.0141 24.0524Z"
        className="reg-avatar"
      />
    </svg>
  );
};

const RegDoubleAvatarSVG = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 36 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1972 19.6742H13.9597V18.4173C17.3621 17.7078 19.8346 15.2499 19.8346 9.32534C19.8346 2.72953 16.1027 0 11.4996 0C6.89647 0 3.16459 2.78632 3.16459 9.32534C3.16459 15.1918 5.58939 17.6584 8.94047 18.3951V19.6742H6.8024C3.04588 19.6742 0 22.7256 0 26.4902V29H23V26.4902C23 22.7256 19.9541 19.6742 16.1972 19.6742Z"
        className="reg-avatar"
      />
      <path
        d="M30.1674 17.2819H28.2491V16.2419C31.1663 15.6547 33.2864 13.6204 33.2864 8.71743C33.2864 3.25869 30.0868 1 26.1401 1C23.4205 1 21.0565 2.09504 19.8489 4.54564C21.0222 5.85582 21.7358 7.78 21.7358 10.4186C21.7358 12.2009 21.4682 13.6215 20.9922 14.743C21.8004 15.5164 22.8108 15.982 23.946 16.2233V17.2819H22.1131C20.5081 17.2819 19.0547 17.9091 18 18.9237H18.4634C21.8433 18.9237 24.5835 21.5737 24.5835 24.8424V25H36V22.9229C36 19.8072 33.3888 17.2819 30.1674 17.2819Z"
        className="reg-avatar"
      />
    </svg>
  );
};

const RegUmberallaSVG = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0655 0.286133C22.6084 0.286133 27.5163 3.07607 30.6332 7.38772C27.2624 7.83861 24.1879 9.33226 21.7338 11.5444C21.2825 11.5163 20.8453 11.488 20.3939 11.488C15.7257 11.488 11.4946 13.4748 8.40581 16.6734H7.92628C5.06325 16.6734 2.3695 17.4061 0 18.7166V18.2798C0 8.34596 7.64414 0.286595 17.065 0.286595L17.0655 0.286133Z"
        className="reg-avatar"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0683 26.7486L14.1885 14.4335L15.6694 13.729L20.2531 25.2128C21.198 28.2423 25.2176 27.4814 24.5406 23.5924C24.6958 22.7188 25.951 22.7611 26.1343 23.536C27.4037 28.1577 21.1839 31.1026 19.0685 26.7485L19.0683 26.7486Z"
        className="reg-avatar"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2823 0C10.8747 0 11.3683 0.380433 11.5376 0.915881C11.1427 1.00044 10.7196 1.12725 10.2964 1.31041C9.85923 1.4936 9.46433 1.70495 9.12584 1.93041C9.02712 1.74723 8.9707 1.53586 8.9707 1.31041C8.9707 0.5918 9.56305 0 10.2823 0H10.2823Z"
        className="reg-avatar"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.60414 19.5898H10.2543C10.5928 19.5898 10.8607 19.8717 10.8607 20.1958V23.5916H14.2598C14.5982 23.5916 14.8662 23.8734 14.8662 24.1975V25.8602C14.8662 26.1983 14.5983 26.4661 14.2598 26.4661H10.8607V29.8619C10.8607 30.2001 10.5928 30.4678 10.2543 30.4678H8.60414C8.26565 30.4678 7.99768 30.2001 7.99768 29.8619V26.4661H4.59865C4.26016 26.4661 3.99219 26.1983 3.99219 25.8602V24.1975C3.99219 23.8734 4.26015 23.5916 4.59865 23.5916H7.99768V20.1958C7.99768 19.8717 8.26565 19.5898 8.60414 19.5898Z"
        className="reg-avatar"
      />
    </svg>
  );
};

const RegselectionSVG = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0665 7.86689H14.7998C16.5331 8.26689 18.0665 9.13356 19.3331 10.4002C20.0665 11.1336 20.7331 12.0002 21.1998 13.0002H24.5331V4.13356C24.5331 3.00023 23.5998 2.06689 22.5331 2.06689H21.0665C21.1331 2.26689 21.1331 2.46689 21.1331 2.73356V5.86689C21.0665 6.93356 20.1998 7.86689 19.0665 7.86689Z"
        className="reg-avatar"
      />
      <path
        d="M19.3333 24.0002C17.5333 25.8002 15.1333 26.8002 12.5333 26.8002C9.93333 26.8002 7.53333 25.8002 5.73333 24.0002C2 20.2669 2 14.2002 5.73333 10.4669C7 9.20023 8.6 8.33356 10.2667 7.93356H5.46667C4.33333 7.93356 3.46667 7.06689 3.46667 5.93356V2.73356C3.46667 2.53356 3.46667 2.26689 3.53333 2.06689H2C0.933333 2.06689 0 3.00023 0 4.13356V28.8002C0 29.9336 0.933333 30.8002 2 30.8002H22.4667C23.6 30.8002 24.4667 29.8669 24.4667 28.8002V21.4002H21.1333C20.7333 22.3336 20.1333 23.2002 19.3333 24.0002Z"
        className="reg-avatar"
      />
      <path
        d="M17.2665 0H7.26647C6.5998 0 5.93314 0.333333 5.46647 0.866667C4.9998 1.33333 4.7998 2 4.7998 2.73333V5.86667C4.7998 6.26667 5.06647 6.53333 5.46647 6.53333H19.1331C19.5331 6.53333 19.7998 6.26667 19.7998 5.86667V2.73333C19.7331 1.2 18.6665 0 17.2665 0Z"
        className="reg-avatar"
      />
      <path
        d="M29.1332 14.3333H20.3332C19.9332 13.2666 19.3332 12.1999 18.4666 11.3333C15.2666 8.13327 9.9999 8.0666 6.7999 11.3333C3.5999 14.5333 3.5999 19.7999 6.7999 22.9999C9.9999 26.1999 15.2666 26.2666 18.4666 22.9999C19.3332 22.1333 19.9332 21.1333 20.3332 19.9999H29.1332C30.7332 19.9999 31.9999 18.7333 31.9999 17.1333C31.9999 15.5999 30.7332 14.3333 29.1332 14.3333ZM16.9999 21.5999C14.5999 23.9999 10.5999 23.9999 8.1999 21.5999C5.7999 19.1999 5.7999 15.1999 8.1999 12.7999C10.5999 10.3999 14.5999 10.3999 16.9999 12.7999C19.3999 15.1999 19.3999 19.1333 16.9999 21.5999Z"
        className="reg-avatar"
      />
      <path
        d="M12.6001 18.1333C14.2001 18.1333 15.4667 16.4 15.4667 14.8667C15.4667 13.2667 14.2001 12 12.6001 12C11.0001 12 9.7334 13.2667 9.7334 14.8667C9.7334 16.4 10.9334 18.1333 12.6001 18.1333Z"
        className="reg-avatar"
      />
      <path
        d="M10.0668 19.2002C9.46683 19.2002 8.86683 19.3335 8.3335 19.6002C8.5335 19.9335 8.80016 20.2669 9.1335 20.6002C10.0668 21.5335 11.2668 22.0669 12.6002 22.0669C13.9335 22.0669 15.1335 21.5335 16.0668 20.6002C16.4002 20.2669 16.6002 19.9335 16.8668 19.6002C16.3335 19.3335 15.7335 19.2002 15.1335 19.2002C15.1335 19.2002 10.0668 19.2002 10.0668 19.2002Z"
        className="reg-avatar"
      />
    </svg>
  );
};

const RegdoctorSVG = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 34 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 0C15.438 0 14.1664 1.27092 14.1664 2.83356H2.83356C1.2716 2.83356 0 4.1038 0 5.66644V22.6664C0 24.2291 1.2716 25.5 2.83356 25.5H31.1664C32.7284 25.5 34 24.2291 34 22.6664V5.66644C34 4.1038 32.7284 2.83356 31.1664 2.83356H19.8336C19.8336 1.27092 18.562 0 17 0ZM17 1.41644C17.7817 1.41644 18.4164 2.05258 18.4164 2.83356V5.66644H15.5836V2.83356C15.5836 2.05258 16.2183 1.41644 17 1.41644ZM10.625 7.08356C12.5786 7.08356 14.1664 8.67238 14.1664 10.625C14.1664 12.5776 12.5786 14.1664 10.625 14.1664C8.67136 14.1664 7.08356 12.5776 7.08356 10.625C7.08356 8.67238 8.67136 7.08356 10.625 7.08356ZM10.625 8.5C9.45336 8.5 8.5 9.45336 8.5 10.625C8.5 11.7966 9.45336 12.75 10.625 12.75C11.7966 12.75 12.75 11.7966 12.75 10.625C12.75 9.45336 11.7966 8.5 10.625 8.5ZM17.7086 12.75H29.0414C29.4331 12.75 29.75 13.0669 29.75 13.4586C29.75 13.8502 29.4331 14.1664 29.0414 14.1664H17.7086C17.3169 14.1664 17 13.8502 17 13.4586C17 13.0669 17.3169 12.75 17.7086 12.75ZM10.625 14.875C12.5786 14.875 14.3385 15.6699 15.47 16.3367C16.4135 16.8936 17 17.9748 17 19.1583V19.6119C17 20.5153 16.3197 21.25 15.4826 21.25H5.76742C4.93034 21.25 4.25 20.5153 4.25 19.6119V19.1583C4.25 17.9748 4.8365 16.8936 5.78 16.3367C6.91152 15.6699 8.67136 14.875 10.625 14.875ZM10.625 16.2914C8.9896 16.2914 7.47932 16.9796 6.49978 17.5566C5.99352 17.8554 5.66644 18.4838 5.66644 19.1583V19.6119C5.66644 19.7591 5.75076 19.8336 5.76742 19.8336H15.4826C15.4992 19.8336 15.5836 19.7591 15.5836 19.6119V19.1583C15.5836 18.4838 15.2565 17.8554 14.7502 17.5566C13.7707 16.9796 12.2604 16.2914 10.625 16.2914ZM20.5414 17H29.0414C29.4331 17 29.75 17.3169 29.75 17.7086C29.75 18.1002 29.4331 18.4164 29.0414 18.4164H20.5414C20.1498 18.4164 19.8336 18.1002 19.8336 17.7086C19.8336 17.3169 20.1498 17 20.5414 17Z"
        className="reg-avatar"
      />
    </svg>
  );
};

const FindAccountSVG = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.569 20.8041C21.569 20.2302 21.7436 19.6691 22.0707 19.1919C22.3979 18.7146 22.8628 18.3427 23.4068 18.123C23.9508 17.9034 24.5494 17.8459 25.1269 17.9579C25.7043 18.0699 26.2348 18.3462 26.6511 18.7521C27.0675 19.158 27.351 19.6751 27.4659 20.238C27.5808 20.8009 27.5218 21.3844 27.2965 21.9147C27.0712 22.445 26.6896 22.8982 26.2 23.2171C25.7104 23.536 25.1349 23.7062 24.5461 23.7062C23.7565 23.7062 22.9993 23.4004 22.441 22.8562C21.8827 22.312 21.569 21.5738 21.569 20.8041ZM19.5508 11.1225H29.5245C29.6911 11.1225 29.8509 11.058 29.9687 10.9432C30.0864 10.8284 30.1526 10.6727 30.1526 10.5103V7.93072C30.1515 7.76905 30.0848 7.61437 29.9672 7.50043C29.8495 7.3865 29.6904 7.32255 29.5245 7.32256H26.8699V7.27358C26.869 6.9235 26.7854 6.57833 26.6256 6.26478C26.4659 5.95123 26.2343 5.67772 25.9487 5.46542C25.5435 5.16355 25.0477 5 24.5377 5C24.0277 5 23.5318 5.16355 23.1266 5.46542C22.8095 5.70938 22.5616 6.02832 22.4064 6.39195C22.2886 6.67174 22.2275 6.97113 22.2264 7.27358V7.32256H19.5508C19.385 7.32255 19.2259 7.3865 19.1082 7.50043C18.9905 7.61437 18.9239 7.76905 18.9228 7.93072V10.5225C18.926 10.6828 18.9937 10.8354 19.1111 10.9476C19.2285 11.0598 19.3864 11.1226 19.5508 11.1225ZM39 11.8776V43.0449C39.0005 43.3018 38.949 43.5563 38.8485 43.7937C38.7479 44.0312 38.6001 44.2469 38.4138 44.4286C38.2274 44.6102 38.0061 44.7542 37.7625 44.8523C37.519 44.9503 37.2579 45.0005 36.9944 45H12.0056C11.7421 45.0005 11.481 44.9503 11.2375 44.8523C10.9939 44.7542 10.7726 44.6102 10.5862 44.4286C10.3999 44.2469 10.2521 44.0312 10.1515 43.7937C10.051 43.5563 9.99945 43.3018 10 43.0449V11.8899C10 11.3714 10.2113 10.8741 10.5874 10.5074C10.9636 10.1408 11.4737 9.93479 12.0056 9.93479H17.0302V10.5225C17.0367 11.1701 17.3035 11.7893 17.7732 12.2472C18.243 12.7051 18.8782 12.9651 19.5425 12.9715H29.5245C30.1888 12.9651 30.824 12.7051 31.2938 12.2472C31.7635 11.7893 32.0303 11.1701 32.0368 10.5225V9.93479H36.9944C37.5263 9.93479 38.0364 10.1408 38.4126 10.5074C38.7887 10.8741 39 11.3714 39 11.8899V11.8776ZM16.7664 27.3429C16.7664 27.6677 16.8987 27.9791 17.1343 28.2087C17.3699 28.4384 17.6894 28.5674 18.0225 28.5674H19.4043V27.6694C19.4042 27.0051 19.578 26.3517 19.9091 25.771C20.2403 25.1904 20.7179 24.7017 21.2969 24.3511C22.186 25.1279 23.3368 25.5595 24.5308 25.564C25.7248 25.5686 26.879 25.1457 27.7743 24.3756C28.3406 24.7298 28.8064 25.2171 29.129 25.7927C29.4517 26.3682 29.6208 27.0136 29.6208 27.6694V28.5633H30.9607C31.2939 28.5633 31.6134 28.4343 31.8489 28.2047C32.0845 27.975 32.2169 27.6636 32.2169 27.3388V17.2899C32.2169 16.9651 32.0845 16.6537 31.8489 16.424C31.6134 16.1944 31.2939 16.0654 30.9607 16.0654H25.0485C24.881 16.0491 24.7135 16.0409 24.5461 16.0409C24.3786 16.0409 24.2111 16.0491 24.0436 16.0654H18.0183C17.6852 16.0654 17.3657 16.1944 17.1301 16.424C16.8945 16.6537 16.7622 16.9651 16.7622 17.2899L16.7664 27.3429ZM33.3348 39.8449C33.3348 39.5988 33.2348 39.3627 33.0567 39.1883C32.8786 39.0139 32.6368 38.9154 32.3843 38.9143H16.5905C16.3488 38.9299 16.1222 39.0346 15.9567 39.207C15.7912 39.3794 15.6991 39.6067 15.6991 39.8429C15.6991 40.079 15.7912 40.3063 15.9567 40.4788C16.1222 40.6512 16.3488 40.7558 16.5905 40.7714H32.3843C32.6364 40.7714 32.8782 40.6738 33.0564 40.5001C33.2347 40.3263 33.3348 40.0906 33.3348 39.8449ZM33.3348 34.6408C33.3348 34.3947 33.2348 34.1586 33.0567 33.9842C32.8786 33.8098 32.6368 33.7113 32.3843 33.7102H16.5905C16.3488 33.7259 16.1222 33.8305 15.9567 34.0029C15.7912 34.1753 15.6991 34.4027 15.6991 34.6388C15.6991 34.875 15.7912 35.1023 15.9567 35.2747C16.1222 35.4471 16.3488 35.5517 16.5905 35.5674H32.3843C32.6364 35.5674 32.8782 35.4698 33.0564 35.296C33.2347 35.1222 33.3348 34.8866 33.3348 34.6408Z"
        className="reg-avatar"
      />
    </svg>
  );
};

const ActivationCodeSVG = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.7595 21.4995H11.3066C10.4296 21.4995 9.58859 21.8479 8.96848 22.468C8.34837 23.0881 8 23.9292 8 24.8061V38.0326C8 38.9095 8.34837 39.7506 8.96848 40.3707C9.58859 40.9908 10.4296 41.3392 11.3066 41.3392H37.7595C38.6365 41.3392 39.4775 40.9908 40.0976 40.3707C40.7178 39.7506 41.0661 38.9095 41.0661 38.0326V24.8061C41.0661 23.9292 40.7178 23.0881 40.0976 22.468C39.4775 21.8479 38.6365 21.4995 37.7595 21.4995ZM25.3597 31.2747V37.2059C25.3597 37.4252 25.2726 37.6354 25.1176 37.7905C24.9626 37.9455 24.7523 38.0326 24.5331 38.0326C24.3138 38.0326 24.1036 37.9455 23.9485 37.7905C23.7935 37.6354 23.7064 37.4252 23.7064 37.2059V31.2747C23.1549 31.0797 22.69 30.696 22.394 30.1914C22.098 29.6868 21.9899 29.0938 22.0888 28.5172C22.1877 27.9406 22.4873 27.4176 22.9346 27.0405C23.3819 26.6634 23.9481 26.4566 24.5331 26.4566C25.1181 26.4566 25.6843 26.6634 26.1315 27.0405C26.5788 27.4176 26.8784 27.9406 26.9773 28.5172C27.0762 29.0938 26.9681 29.6868 26.6721 30.1914C26.3761 30.696 25.9113 31.0797 25.3597 31.2747Z"
        className="reg-avatar"
      />
      <path
        d="M21.2307 11.1665C20.7742 11.1665 20.4041 11.5366 20.4041 11.9932C20.4041 12.4497 20.7742 12.8198 21.2307 12.8198H27.8439C28.3005 12.8198 28.6706 12.4497 28.6706 11.9932C28.6706 11.5366 28.3005 11.1665 27.8439 11.1665H21.2307Z"
        className="reg-avatar"
      />
      <path
        d="M23.5998 8.71591C23.3715 8.32053 22.8659 8.18506 22.4705 8.41333C22.0752 8.64161 21.9397 9.14718 22.168 9.54256L25.4746 15.2698C25.7029 15.6652 26.2084 15.8006 26.6038 15.5724C26.9992 15.3441 27.1347 14.8385 26.9064 14.4431L23.5998 8.71591Z"
        className="reg-avatar"
      />
      <path
        d="M22.1639 14.4438C21.9356 14.8392 22.0711 15.3447 22.4665 15.573C22.8619 15.8013 23.3674 15.6658 23.5957 15.2704L26.9023 9.5432C27.1306 9.14782 26.9951 8.64225 26.5997 8.41398C26.2044 8.1857 25.6988 8.32117 25.4705 8.71655L22.1639 14.4438Z"
        className="reg-avatar"
      />
      <path
        d="M12.1291 15.3037C11.6726 15.3037 11.3025 15.6738 11.3025 16.1304C11.3025 16.5869 11.6726 16.957 12.1291 16.957H18.7424C19.1989 16.957 19.569 16.5869 19.569 16.1304C19.569 15.6738 19.1989 15.3037 18.7424 15.3037H12.1291Z"
        className="reg-avatar"
      />
      <path
        d="M14.5004 12.8526C14.2721 12.4572 13.7666 12.3218 13.3712 12.5501C12.9758 12.7783 12.8403 13.2839 13.0686 13.6793L16.3752 19.4065C16.6035 19.8019 17.1091 19.9374 17.5044 19.7091C17.8998 19.4808 18.0353 18.9752 17.807 18.5798L14.5004 12.8526Z"
        className="reg-avatar"
      />
      <path
        d="M13.0645 18.5771C12.8363 18.9725 12.9717 19.478 13.3671 19.7063C13.7625 19.9346 14.2681 19.7991 14.4963 19.4037L17.8029 13.6765C18.0312 13.2811 17.8958 12.7756 17.5004 12.5473C17.105 12.319 16.5994 12.4545 16.3711 12.8499L13.0645 18.5771Z"
        className="reg-avatar"
      />
      <path
        d="M30.7454 15.3037C30.2888 15.3037 29.9187 15.6738 29.9187 16.1304C29.9187 16.5869 30.2888 16.957 30.7454 16.957H37.3586C37.8151 16.957 38.1852 16.5869 38.1852 16.1304C38.1852 15.6738 37.8151 15.3037 37.3586 15.3037H30.7454Z"
        className="reg-avatar"
      />
      <path
        d="M33.1112 12.8551C32.883 12.4597 32.3774 12.3242 31.982 12.5525C31.5866 12.7808 31.4512 13.2863 31.6794 13.6817L34.9861 19.4089C35.2143 19.8043 35.7199 19.9398 36.1153 19.7115C36.5107 19.4832 36.6461 18.9777 36.4179 18.5823L33.1112 12.8551Z"
        className="reg-avatar"
      />
      <path
        d="M31.682 18.5795C31.4537 18.9749 31.5892 19.4805 31.9845 19.7087C32.3799 19.937 32.8855 19.8015 33.1138 19.4062L36.4204 13.6789C36.6487 13.2836 36.5132 12.778 36.1178 12.5497C35.7224 12.3214 35.2168 12.4569 34.9886 12.8523L31.682 18.5795Z"
        className="reg-avatar"
      />
    </svg>
  );
};

export {
  RegAvatarSVG,
  RegDoubleAvatarSVG,
  RegUmberallaSVG,
  RegselectionSVG,
  RegdoctorSVG,
  ActivationCodeSVG,
  FindAccountSVG,
};
